<template>
    <div class="w-full">
        <custom-simple-select
            v-model="option"
            mode="search"
            class="w-full"
            :label="label"
            :disabled="!enabled"
            :options="cityOptions"
            @change="onInput"
        />
    </div>
</template>

<script>
import { ENABLED_CITIES } from "@/common/constants";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "CitiesCodesSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            type: String,
            default: () => "",
            required: false
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        label: {
            default: () => "Ciudad",
            type: String,
            required: false
        }
    },
    emits: ["change"],
    data() {
        return {
            option: this.itemsCurrent,
            $enabledOptions: ENABLED_CITIES
        };
    },
    computed: {
        cityOptions() {
            return Object.entries(this.$data.$enabledOptions).map(
                ([key, value]) => ({
                    label: value,
                    value: key
                })
            );
        }
    },
    watch: {
        itemsCurrent(value) {
            this.option = value;
        }
    },
    methods: {
        onInput(value) {
            this.$emit("change", value);
        }
    }
};
</script>
